import { defineTypes, createLoader } from 'helpers/duckTools';
import { combineReducers } from 'redux';
import api from 'store/actions/api';
import { getModelsResult, getSubTypesResult } from './resultSelectors';

const defaultState = {};

const modelTypes = defineTypes(['SET'], 'VEHICLE/MODEL');
const subTypes = defineTypes(['SET'], 'VEHICLE/SUBTYPE');

const modelSet = (payload, ...fetchArgs) => ({
  type: modelTypes.SET,
  payload,
  fetchArgs,
});

const subTypeSet = (payload, ...fetchArgs) => ({
  type: subTypes.SET,
  payload,
  fetchArgs,
});

export const loadModel = createLoader({
  fetch: (manufacturer) => api.getCarMainTypes({ manufacturer }),
  resultSelector: getModelsResult,
  set: modelSet,
});

export const loadSubType = createLoader({
  fetch: (manufacturer) => api.getCarSubTypes({ manufacturer }),
  resultSelector: getSubTypesResult,
  set: subTypeSet,
});

const modelDuck = (state = defaultState, { type, payload, fetchArgs }) => {
  switch (type) {
    case modelTypes.SET: {
      const [make] = fetchArgs;

      return {
        ...state,
        [make]: {
          ...(state[make] || {}),
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

const subTypeDuck = (state = defaultState, { type, payload, fetchArgs }) => {
  switch (type) {
    case subTypes.SET: {
      const [make] = fetchArgs;

      return {
        ...state,
        [make]: {
          ...(state[make] || {}),
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

export const reducer = combineReducers({
  model: modelDuck,
  subType: subTypeDuck,
});
